package org.braunequip.web.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.toImage
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.cssRem

/*
    Equipment Services Hero Section
*/
val equipmentHeroBg = CssStyle {
    base {
        Modifier
            .background(
                Background.of(
                    image = BackgroundImage.of(url("equipmentHeader.jpg")),
                    position = BackgroundPosition.of(CSSPosition.Bottom),
                    size = BackgroundSize.Cover,
                ),
                Background.of(image = linearGradient(Color.rgba(0, 0, 0, 0.5f), Color.rgba(0, 0, 0, 0.5f)).toImage())
            )
    }
}

/*
    Rental Card Section
*/
val RentalDescriptionContainer = CssStyle {
    base {
        Modifier
            .padding(topBottom = 2.cssRem)
            .fillMaxWidth()
            .backgroundColor(Colors.WhiteSmoke)
    }
    Breakpoint.MD {
        Modifier
            .fillMaxWidth()
    }
}